import styled from 'styled-components';
import {colors} from '../../../utils/styled/_variables.styled';

export const KoerberContainedLabel = styled.label`
    color: ${colors.gray5};
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: 16px;
    transition: 0.2s;
`

export const KoerberContainedDropdownLabel = styled.label`
    position: absolute;
    pointer-events: none;
    font-size: 14px;
    font-weight: 400;
    background-color:#fff;
    padding:0 5px 0 5px;
    transition: 0.2s;
    color: ${colors.gray5};
    left: 7px;
    top: 11px;
    transition: 0.2s;
`
